import { render, staticRenderFns } from "./menu-products-own.vue?vue&type=template&id=d7a03f6e&scoped=true&lang=pug"
import script from "./menu-products-own.vue?vue&type=script&lang=ts"
export * from "./menu-products-own.vue?vue&type=script&lang=ts"
import style0 from "./menu-products-own.vue?vue&type=style&index=0&id=d7a03f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a03f6e",
  null
  
)

export default component.exports